import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    OnInit,
    Signal,
    signal,
    ViewChild,
    WritableSignal,
} from "@angular/core";

import { toSignal } from "@angular/core/rxjs-interop";

import { filter, map, merge, Observable } from "rxjs";

import { CloseButtonComponent } from "@hermes/aphrodite-close-button";
import { BannerItem, BannersData } from "@hermes/api-model-shell";

import { Context, StorageManager, StorageService } from "@hermes/core-app-core";

import { ShellFacade } from "@hermes/domains-shell-states-shell-state";
import {
    ENABLE_NEW_NOTIFICATION_BANNER,
    FeatureFlagFacade,
} from "@hermes/hermes-web-states-flipper-state";

import { UserAgentPlatformService } from "@hermes/utils-generic-services-user-agent-platform";

import { NOTIFICATIONSHIDE } from "../../../constants/cookie.constants";
import { isBannerItemsNotEmpty } from "../../../helpers/banner.helper";
import { NotificationMessageComponent } from "../notification-message/notification-message.component";

@Component({
    selector: "h-notification-modal",
    imports: [CommonModule, NotificationMessageComponent, CloseButtonComponent],
    templateUrl: "./notification-modal.component.html",
    styleUrls: ["./notification-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationModalComponent implements OnInit {
    public readonly context = inject(Context);
    private readonly featureFlagFacade = inject(FeatureFlagFacade);
    private readonly shellFacade = inject(ShellFacade);
    private readonly storageService = inject(StorageService);
    public readonly isMobile = inject(UserAgentPlatformService).isMobileSignal;

    private readonly banners$: Observable<BannersData>;
    private readonly sessionStorage: StorageManager | undefined;

    @ViewChild("closeButton")
    public closeButton!: ElementRef<HTMLButtonElement>;

    public isNewNotificationBannerEnable: Signal<boolean>;

    public notificationsBanners$: Observable<BannerItem[] | undefined>;

    public hideWithAnimation: WritableSignal<boolean> = signal(false);
    public showWithAnimation: WritableSignal<boolean> = signal(false);

    constructor() {
        this.isNewNotificationBannerEnable = toSignal(
            this.featureFlagFacade.isActivated(ENABLE_NEW_NOTIFICATION_BANNER),
            { initialValue: false },
        );

        this.sessionStorage = this.storageService.getSessionStorageInstance();

        this.banners$ = this.shellFacade.getBanners();

        this.notificationsBanners$ = merge(
            this.banners$.pipe(
                map((banners) => banners.notifications),
                filter(isBannerItemsNotEmpty),
            ),
        );
    }

    public ngOnInit(): void {
        if (
            this.context.isInBrowserMode() &&
            !this.sessionStorage?.getItem(NOTIFICATIONSHIDE)
        ) {
            this.showWithAnimation.set(true);
        }
        this.notificationsBanners$ = this.banners$.pipe(
            map((banners) => banners.notifications),
        );
    }

    public close(): void {
        this.sessionStorage?.setItem(NOTIFICATIONSHIDE, true);
        this.hideWithAnimation.set(true);
        this.showWithAnimation.set(false);
    }
}
